export const endpoints = {
  experienceTransferItem: 'experienceTransfer',
  operationOptions: 'experienceTransfer/operationaccess/operation/options',
  caseTypeOptions: 'experienceTransfer/caseType/options',
  criteriaOptions: 'experienceTransfer/criteria/options',
  subscriberGroupOptions: 'subscriberGroup/options'
};
